import React, { createRef } from 'react';

import { AlertConfirm } from './ConfirmationPopups';
import ReactDOM from 'react-dom';
import Loader from "../Common/Loader";
import { AsyncAjaxGet } from '../Common/AsyncAjaxService';
import { UserContext } from 'vagaro-website-rendering/src/components/Definitions/UserContext';
import { ValidateToken } from 'vagaro-website-rendering/src/components/Utilities/BusinessData';


type imageCol = {
    images:any[];
    height:number;
}

export default function UnsplashMenu({onSelect,userContext}:{onSelect:Function,userContext:UserContext}){

    const searchRef = createRef<HTMLInputElement>();

    const [imageResult,setImageResult] = React.useState<any>(null);

    const [currentPage,setPage] = React.useState<number>(1);

    const [hasSearched,setHasSearched] = React.useState<boolean>(false);
   
    const [searched,setSearched] = React.useState<string>("");

    const search = (page:number = 1,applySearch = false)=>{

        let searchVal = searched;
        if(applySearch && searchRef.current){
            setSearched(searchRef.current.value);
     
            searchVal = searchRef.current.value;

        }
 
        if(searchVal.length>0){       
            document.getElementById("unsplash-popup")?.classList.add("expanded");
            setHasSearched(true);
            setPage(page);
            setImageResult(null);
        UnsplashImageSearch(userContext,searchVal,page,(data)=>{

            setImageResult(data.data);
            
        },(data)=>{
            setHasSearched(true);
            AlertConfirm("Failed to load image results, please try again later!");
            setImageResult(null);
        })

    }
        else{
            AlertConfirm("Please enter a search term to search for images");

        }
    }

 
    let columns:imageCol[] = [
        {height:0,images:[]},
        {height:0,images:[]},
        {height:0,images:[]},
        {height:0,images:[]},
    ]


    if(imageResult && imageResult.results && imageResult.results.length>0){


        //sort largest to smallest for better distribution
        imageResult.results.sort ((a:any,b:any)=>{ return  - ((a.height/a.width) - (b.height/b.width))});
        
        imageResult.results.forEach((image:any,index:number)=>{

         
            let col = columns[0];

            for(let i = 0;i<columns.length;i++){
                if(columns[i].height < col.height){
                    col = columns[i];
                }
            }
            col.images.push(image);
            col.height += image.height/image.width;



        })
   
        //shuffule the columns deterministically using the user id of each photo to readd variance
        columns.forEach((col:imageCol,index:number)=>{

            col.images.sort((a:any,b:any)=>{return (a.user.id.localeCompare(b.user.id))});
        })

    }

    const ImageColumn = ({images}:{images:any[]})=>{



        return (
            <div className='flex-column gap-med h-full w-full'>
            {images.map((image:any,index:number)=>{

                return <div key = {index} className='w-full stock-container'><img  className='stock-image w-full' loading='lazy'  src={image.urls.small } alt = {`By ${image.user.name} | Unsplash`}
                
                onClick={()=>ImagePreview(userContext,image,(url:string)=>{

                    setTimeout(()=>{onSelect(url,image)},0);
             
                
                
                })}
                
                />
                
                    <div className="stock-info ">
                    <img  style={{borderRadius:"100%"}} src ={image.user.profile_image.small} alt={image.user.name } loading='lazy'/>
                        <div>
                            <div>  Photo By {image.user.name} | Unsplash </div>
                            <div className='font-small'>1080 X {Math.round((image.height/image.width)*1080)}</div>
                        </div>
                    </div>
                </div>

            })}
            
            
            </div>
        )
    }

    const Pagination = ()=>{

return <div className='flex-row gap-small justify-center' style={{marginTop:"20px"}}>
    {imageResult && currentPage>1 && <button className='w-button w-button-secondary' onClick={()=>search(currentPage-1)}>Prev</button>}

     {imageResult && imageResult.total_pages > 1 && 

        [1,2,3,4,5].map((index:number)=>{

            const relative =  currentPage+(index-3);

            if(relative < 1 || relative > imageResult.total_pages){
                return null;
            }

            if(relative == currentPage){
                return <div  key ={index} className='w-button w-button-primary' style={{pointerEvents:"none"}}>{currentPage}</div>
            }

            return <button key={index} className='w-button w-button-secondary' onClick={()=>search(relative)}>{relative}</button>


        })

    }

    {imageResult && currentPage<imageResult.total_pages && <button className='w-button w-button-secondary' onClick={()=>search(currentPage+1)}>Next</button>}
    </div>
    
    }

    return (
    <div className='wb-input-group no-border' style={{minWidth: hasSearched?"75vw":"", padding:"0px"}}>
            <div className="flex-row gap-med"> 
            <input type="text" className='w-full' id='unsplash-search' placeholder="Search for images..." ref = {searchRef} 
            onKeyDown={(e)=>{

                if(e.key == "Enter")
                    search(1,true);

            }}
            
            />
                <button className='w-button w-button-primary' onClick={()=>search(1,true)}>Search</button>
            </div>
            <div className="flex-column gap-med unsplash-content" style={{height:(hasSearched?"calc(90vh - 200px)":"auto"),padding:"4px",marginTop:"12px",overflow:"auto"}} >



             {
              imageResult&&imageResult.results.length<=0 && hasSearched&&
                    
                 
                    <div className='center-all w-full h-full' style={{height:"100%"}}>No Images Found</div>
                  
                }
                { !imageResult && hasSearched &&
                      <div className="center-all w-full h-full">
                   <Loader/>
                        </div>
                }
            
            <div className="flex-row gap-med align-start" >
                { (columns[0].images.length>0) && 
                    <>
                    <ImageColumn images={columns[0].images} />
                    <ImageColumn images={columns[1].images} />
                    <ImageColumn images={columns[2].images} />
                    <ImageColumn images={columns[3].images} />
                    </>

                }
              
            </div>
            {   columns[0].images.length>0  && 
                <Pagination />
            }
            </div>

    </div>

    )


}

const referral = "?utm_source=vagaro_my_site&utm_medium=referral"

function ImagePreview(userContext:UserContext,previewImage:any,onConfirm=(image:string)=>{},onDismiss=()=>{}){

    const dismiss = ()=>{
        let dom = document.getElementById("OpenDialog1");
        if(dom)
        ReactDOM.unmountComponentAtNode(dom)

    }

    if(!previewImage.width)
        return;

    let imgStyle = {width:"1080px",height:"auto",maxWidth:"100%"};

    ReactDOM.render(
    <div className='w-full h-full flex-column justify-center align-center vanimation-fade-in gap-med unsplash-image-preview block-edit'  style={{position:"fixed",background:"#000000cc",top:"0",left:"0",zIndex:"6000",opacity:"0"}} >

        <div className='flex-column ' style={{maxWidth:"80vw",maxHeight:"90vh",padding:"32px 16px 0px 16px",background:"white",borderRadius:"6px",position:"relative"}}>
            <button className='invisible-button ' style={{position:"absolute",top:"0px",right:"6px",fontSize:"24px",fontWeight:"bold",color:"#333"}}
                    onClick={()=>{onDismiss(); dismiss();
                    }}
                >&times;</button>
            <div className = "w-full h-full relative" style={{overflow:"auto"}}>
            {/* <img style={imgStyle} width = {previewImage.width} height={previewImage.height} src={ previewImage.urls.thumb } alt = {`Photo By ${previewImage.user.name} | Unsplash`} /> */}
  
            <img style={imgStyle} width = {previewImage.width} loading='lazy' height={previewImage.height} src={ previewImage.urls.regular  } alt = {`By ${previewImage.user.name} | Unsplash`} />
                </div>
            <div className = "flex-row w-full justify-between flex-wrap" style={{padding:"8px 4px"}} >
                <div className='flex-row ' style={{minWidth:"240px",padding:"8px",position:"relative"}}>

                    <div > <span className='flex-row gap-med unsplash-credit' style={{color:"black"}} >
                    <img  style={{borderRadius:"100%"}} src ={previewImage.user.profile_image.small} alt={previewImage.user.name }/>

                    Photo By <a target='_blank' rel="noreferrer" href={previewImage.user.links.html+referral}>{previewImage.user.name}</a> | <a target='_blank' rel="noreferrer" href={'https://unsplash.com/'+referral}>Unsplash</a>  <a  rel="noreferrer" target="_blank" href= {previewImage.links.html+referral}>1080 X {Math.round((previewImage.height/previewImage.width)*1080)}</a></span>
                    
                    </div>
                </div>
                <div className='flex-row gap-med'>
                    <button className='w-button w-button-secondary'
                    onClick={()=>{
                        onDismiss();
                    
                        dismiss()}}
                    >Cancel</button>
                    <button className='w-button w-button-primary'
                   
                        onClick={()=>{
                            UnplashCreditImageDownload(userContext,previewImage.links.download_location);
                            onConfirm(previewImage.urls.regular);
                             onDismiss();
                              dismiss();}}
                    
                    >Add Image</button>
                </div>
            </div>
        </div>
       
    </div>,


        document.getElementById("OpenDialog1")
    )

}



export async function UnsplashImageSearch(userContext:UserContext,searchParams:string,page:number = 1,onSuccess=(data:any)=>{},onFailure = (data:any)=>{}){

    const url = "unsplash/getunsplashphoto?page=" + page + "&query=" + searchParams + "&per_page=30";

    await ValidateToken(userContext);

    await AsyncAjaxGet(url,userContext.accessToken,(data:any)=>{onSuccess(data.data)},(data:any)=>{onFailure(data)});

}

export async function UnplashCreditImageDownload(userContext:UserContext,url:string){

    const concactUrl = "unsplash/getunsplashphotodownloadurl?downloadlocation="+url;

    await ValidateToken(userContext);
    //since this is simply a trigger for unsplash we don't need to handle response regardless of fail or success
    await AsyncAjaxGet(concactUrl,userContext.accessToken,(data:any)=>{},(data:any)=>{});

   
}